import { useMemo } from "react";
import {
  AdultPassengerFormValue,
  ChildPassengerFormValue,
} from "../../../../types";
import { FlightPrebookPassengerFormValue } from "../../../types";

type Params = {
  isInfant: boolean;
  defaultValues: FlightPrebookPassengerFormValue;
  catalogBaggageAddOns: Record<string, any[]> | null;
};

export function useBaggageInfos({
  isInfant,
  defaultValues,
  catalogBaggageAddOns,
}: Params) {
  return useMemo(() => {
    if (isInfant) return [];
    const addOns =
      (defaultValues as AdultPassengerFormValue | ChildPassengerFormValue)
        .addOns ?? [];

    return addOns
      .map((trip, tripIdx) =>
        trip.map(
          ({ departureAirport, arrivalAirport, journeys }, journeyIdx) => {
            const isSegmentsArray = Array.isArray(journeys);
            const segments = isSegmentsArray ? journeys : [journeys];

            return {
              departureAirport: `${departureAirport.city} (${departureAirport.airportCode})`,
              arrivalAirport: `${arrivalAirport.city} (${arrivalAirport.airportCode})`,
              segments: segments.map((segment, segmentIdx) => {
                const { departureAirport, arrivalAirport } = segment;
                const catalogIdx = `${departureAirport.airportCode}-${arrivalAirport.airportCode}`;
                return {
                  ...segment,
                  name: isSegmentsArray
                    ? `addOns.${tripIdx}.${journeyIdx}.journeys.${segmentIdx}`
                    : `addOns.${tripIdx}.${journeyIdx}.journeys`,
                  catalog: catalogBaggageAddOns?.[catalogIdx] || [],
                };
              }),
            };
          }
        )
      )
      .flat();
  }, [catalogBaggageAddOns, defaultValues, isInfant]);
}
